// extracted by mini-css-extract-plugin
export default {"root":"DataTable_root__RQRlX","placeHolderShimmer":"DataTable_placeHolderShimmer__P+FZV"};